function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Path_1023",
  x: 0,
  y: 0,
  width: 31,
  height: 31,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#c89609",
  floodOpacity: 0.31
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3374",
  "data-name": "Group 3374",
  transform: "translate(-960.5 -712.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 960.5, 712.5)",
  filter: "url(#Path_1023)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1023-2",
  "data-name": "Path 1023",
  d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
  transform: "translate(4.5 2.5)",
  fill: "#fffbdc"
})), /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-star",
  "data-name": "Icon awesome-star",
  d: "M5.385.293,4.306,2.48l-2.413.352a.529.529,0,0,0-.292.9l1.745,1.7-.413,2.4a.528.528,0,0,0,.766.557L5.859,7.259,8.017,8.393a.529.529,0,0,0,.766-.557l-.413-2.4,1.745-1.7a.529.529,0,0,0-.292-.9L7.411,2.48,6.333.293a.529.529,0,0,0-.948,0Z",
  transform: "translate(970.141 721.772)",
  fill: "#ffcc01"
}));

function SvgStarCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCircle);
export default __webpack_public_path__ + "static/media/star-circle.297312d0.svg";
export { ForwardRef as ReactComponent };